import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "custom-font-text" }
const _hoisted_2 = {
  key: 0,
  class: "secondary-selection"
}
const _hoisted_3 = { class: "custom-font-text" }
const _hoisted_4 = { class: "optional" }
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "choose-language" }
const _hoisted_7 = { class: "choose-language" }
const _hoisted_8 = ["data-testid", "onChange"]
const _hoisted_9 = ["selected"]
const _hoisted_10 = ["value", "selected"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_autocomplete = _resolveComponent("autocomplete")!
  const _component_VJoyButton = _resolveComponent("VJoyButton")!

  return (_openBlock(), _createElementBlock("div", {
    onFocusin: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.emitFocus && _ctx.emitFocus(...args)))
  }, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.languages.title')), 1),
    _createElementVNode("p", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.$msg('profile.creation.completion.wizard.languages.subtitle')) + " ", 1),
      _createElementVNode("a", {
        class: "open-bottom-sheet",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openBottomSheet && _ctx.openBottomSheet(...args)))
      }, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.languages.help')), 1)
    ]),
    _createVNode(_component_autocomplete, {
      "autocomplete-service": _ctx.searcher,
      "model-value": _ctx.defaultValue,
      "no-options-label": _ctx.$msg('profile.creation.completion.wizard.languages.notfound'),
      placeholder: _ctx.$msg('lang.english'),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = (item) => _ctx.selectLang(0, item)),
      "onAutocomplete:clear": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectLang(0, null)))
    }, {
      default: _withCtx((slotProps) => [
        _createTextVNode(_toDisplayString(slotProps.option.name), 1)
      ]),
      _: 1
    }, 8, ["autocomplete-service", "model-value", "no-options-label", "placeholder"]),
    (_ctx.isNativeLanguageSelected)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.$msg('profile.creation.completion.wizard.languages.title.more')) + " ", 1),
            _createElementVNode("span", _hoisted_4, "- " + _toDisplayString(_ctx.$msg('profile.creation.common.field.title.optional')), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additionalLanguages, (lang, index) => {
            return (_openBlock(), _createElementBlock("div", {
              id: `${lang.id}`,
              key: lang.id,
              class: "l-row-custom"
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_autocomplete, {
                  "autocomplete-service": _ctx.searcher,
                  "model-value": _ctx.langs[lang.id].query,
                  "no-options-label": _ctx.$msg('profile.creation.completion.wizard.languages.notfound'),
                  placeholder: _ctx.$msg('lang.english'),
                  "data-testid": `add-language-${index}`,
                  "onUpdate:modelValue": (item) => _ctx.selectLang(lang.id, item),
                  "onAutocomplete:clear": ($event: any) => (_ctx.selectLang(lang.id, null))
                }, {
                  default: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(slotProps.option.name), 1)
                  ]),
                  _: 2
                }, 1032, ["autocomplete-service", "model-value", "no-options-label", "placeholder", "data-testid", "onUpdate:modelValue", "onAutocomplete:clear"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("select", {
                  class: "m-select",
                  "aria-label": "langLevel",
                  name: "level",
                  "data-testid": `language-level-select-${index}`,
                  onChange: (e) => _ctx.selectLevel(lang.id, e)
                }, [
                  _createElementVNode("option", {
                    disabled: "",
                    selected: _ctx.noLevelSelected(lang.id)
                  }, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.languages.level')), 9, _hoisted_9),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.langsLevel, (langLevel) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: langLevel.level,
                      selected: _ctx.isLevelSelected(lang.id, langLevel.level)
                    }, _toDisplayString(langLevel.text), 9, _hoisted_10))
                  }), 256))
                ], 40, _hoisted_8)
              ]),
              (_ctx.isRemovableLanguage(lang))
                ? (_openBlock(), _createBlock(_component_VJoyButton, {
                    key: 0,
                    circle: "",
                    variant: "ghost",
                    icon: "trash",
                    class: "remove-language",
                    onClick: ($event: any) => (_ctx.removeAdditionalLanguage(lang.id))
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_5))
          }), 128)),
          _createElementVNode("joy-divider-cta", {
            "data-testid": "add-language",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showAdditionalLanguage && _ctx.showAdditionalLanguage(...args)))
          }, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.v2.languages.action.add')), 1)
        ]))
      : _createCommentVNode("", true)
  ], 32))
}